import React from 'react';
import { Trans } from '@lingui/react/macro';
import { ResidentialUnit, ResidentialUnitGroup } from '@/types';
import { InternalLinkButton } from '@/components/Buttons';
import theme from './ResidentialUnitGroupingHeader.module.scss';
import { Sticky } from '@ygtechnologies/bygr-frontend-component-library';
import classNames from 'classnames';

interface OwnProps {
    residentialUnit: ResidentialUnit;
    residentialUnitGroup: ResidentialUnitGroup | null;
    detailsLinkTab: 'documents' | 'options' | 'orders' | 'changes' | 'external-agreements';
}

const ResidentialUnitGroupingHeader: React.FC<OwnProps> = ({ residentialUnit, residentialUnitGroup, detailsLinkTab }) => {
    // return (
    //     <Sticky className={theme.container} stickyClassName={theme.sticky}>
    //         {[residentialUnitGroup, residentialUnit]
    //             .filter((x) => !!x)
    //             .map((x) => x!.name)
    //             .join(' - ')}

    //         <InternalLinkButton
    //             className={theme.detailsLink}
    //             to={`/projects/${residentialUnit.projectId}/residential-units/${residentialUnit.id}/${detailsLinkTab}`}>
    //             <Trans>View unit details</Trans>
    //         </InternalLinkButton>
    //     </Sticky>
    // );

    return (
        <Sticky className={theme.container} stickyClassName={classNames(theme.sticky, 'stickyBleed')}>
            {[residentialUnitGroup, residentialUnit]
                .filter((x) => !!x)
                .map((x) => x!.name)
                .join(' - ')}

            <InternalLinkButton
                className={theme.detailsLink}
                to={`/projects/${residentialUnit.projectId}/residential-units/${residentialUnit.id}/${detailsLinkTab}`}>
                <Trans>View unit details</Trans>
            </InternalLinkButton>
        </Sticky>
    );
};

export default ResidentialUnitGroupingHeader;
